/**
 * affiliateTracker — détection et persistance du code d'affilié via UTM
 *
 * Au premier chargement de page, on lit ?utm_source=... s'il est présent.
 * Si oui, on stocke le code dans localStorage pour 30 jours.
 * Le code est ensuite envoyé au backend à chaque checkout pour attribuer la commission.
 */
import { api } from "./api";

const STORAGE_KEY = "aff_code";
const STORAGE_EXPIRES_KEY = "aff_expires_at";
const COOKIE_DAYS = 30;

function setAffiliate(code, campaign) {
  const expiresAt = Date.now() + COOKIE_DAYS * 24 * 60 * 60 * 1000;
  try {
    localStorage.setItem(STORAGE_KEY, code);
    localStorage.setItem(STORAGE_EXPIRES_KEY, String(expiresAt));
    // Track click (fire-and-forget)
    api.post("/affiliates/track-click", null, {
      params: { code, campaign: campaign || "default" },
    }).catch(() => {});
  } catch {
    /* ignore */
  }
}

/** Returns the current affiliate code or null if none/expired. */
export function getAffiliate() {
  try {
    const code = localStorage.getItem(STORAGE_KEY);
    const expires = Number(localStorage.getItem(STORAGE_EXPIRES_KEY) || 0);
    if (!code || !expires) return null;
    if (Date.now() > expires) {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(STORAGE_EXPIRES_KEY);
      return null;
    }
    return code;
  } catch {
    return null;
  }
}

/** Call once at app boot — looks for ?utm_source=... in the URL and persists. */
export function initAffiliateTracking() {
  try {
    const params = new URLSearchParams(window.location.search);
    const source = (params.get("utm_source") || "").trim().toLowerCase();
    const medium = (params.get("utm_medium") || "").trim().toLowerCase();
    const campaign = (params.get("utm_campaign") || "default").trim();
    const content = (params.get("utm_content") || "").trim();
    const term = (params.get("utm_term") || "").trim();

    // 1) Log ALL UTM-tagged visits for internal analytics (Wix → boutique, ads, etc.)
    if (source) {
      api.post("/utm/track", {
        utm_source: source,
        utm_medium: medium,
        utm_campaign: campaign,
        utm_content: content,
        utm_term: term,
        landing_path: window.location.pathname,  // strip query params for cleaner analytics
        referrer: document.referrer || "",
      }).catch(() => { /* silent */ });
    }

    // 2) Attribute to an affiliate only when the medium indicates it (server double-checks the code)
    if (source && (medium === "affiliation" || medium === "" || medium === "partner")) {
      setAffiliate(source, campaign);
    }
  } catch {
    /* ignore */
  }
}
